<template>
  <div id="demonstration">
    <div class="wrap">
      <popups text="预约演示" anonymous="hide" @onOff="$emit('onOff', 'dem')" type="dem" @confirm="confirm">
        <div class="description">大管加还能为您的企业带来哪些改变？请留下联系方式，我们将免费为您上门演示。</div>
        <div class="content">
          <form>
            <div class="name">
              <input type="text" placeholder="姓名" v-model.trim="userName">
            </div>
            <div class="phone">
              <input type="number" placeholder="手机" v-model.number="userPhone">
            </div>
            <div class="company">
              <input type="text" placeholder="公司全称" v-model.trim="userCompany">
            </div>
            <div class="address">
              <input type="text" placeholder="详细地址" v-model.trim="companyAddress">
            </div>
            <div class="describe">
              <textarea placeholder="请输入公司的其他相关信息，如行业、规模等" v-model.trim="describe"></textarea>
            </div>
          </form>
        </div>
      </popups>
    </div>
  </div>
</template>

<script>
import popups from '../popups/popups'
import {mapActions} from 'vuex'
import axios from 'axios'

export default {
  name: 'demonstration',
  components: {
    popups
  },
  props: {
    text: String
  },
  data () {
    return {
      userName: '',
      userPhone: '',
      userCompany: '',
      companyAddress: '',
      describe: '',
    }
  },
  methods: {
    ...mapActions([
      'action_sendMpBespoke'
    ]),
    confirm () {
      if (!this.userName.length || !this.userPhone.toString().length || !this.userCompany.length || !this.companyAddress.length || !this.describe.length) {
        this.showMessage('您还有信息未完善')
        return false
      }
      if (this.userPhone.toString().length !== 11) {
        this.showMessage('请输入11位手机号')
        return false
      }
      let self = this
      let xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP")
      let params = {
        name: this.userName,
        phone: this.userPhone,
        companyName: this.userCompany,
        address: this.companyAddress,
        description: this.describe,
        clientType: 2
      }
      params = JSON.stringify(params)

      xhr.open('post', 'https://www.erplus.co/base/inviteShow')
      xhr.setRequestHeader('Content-type', 'application/json')
      xhr.send(params)

      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4 && xhr.status === 200) {
          let response = JSON.parse(xhr.responseText)
          if (response.erpCode === '000') {
            self.$message({
              type: 'success',
              message: '预约成功！',
              showClose: true
            })
          } else {
            let msg = response.erpMsg || '预约失败'
            self.$message({
              type: 'error',
              message: msg,
              showClose: true
            })
          }
        }
      }
    }
  }
}
</script>

<style scoped>
  ::-webkit-input-placeholder { /* WebKit browsers */
    font-size: 15px;
    color: #CCCCCC;
    letter-spacing: 0;
  }

  :-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    font-size: 15px;
    color: #CCCCCC;
    letter-spacing: 0;
  }

  ::-moz-placeholder { /* Mozilla Firefox 19+ */
    font-size: 15px;
    color: #CCCCCC;
    letter-spacing: 0;
  }

  :-ms-input-placeholder { /* Internet Explorer 10+ */
    font-size: 15px;
    color: #CCCCCC;
    letter-spacing: 0;
  }

  #demonstration {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1000;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
  }

  .wrap {
    box-sizing: border-box;
    position: fixed;
    left: 50%;
    top: 50%;
    z-index: 1000;
    transform: translate(-50%, -50%);
    width: 580px;
    height: 680px;
    padding: 38px 35px 38px 40px;
    background: #fff;
  }

  .description {
    margin-top: 20px;
    font-size: 18px;
    color: #333333;
    line-height: 30px;
    letter-spacing: 0;
  }

  .content {
    width: 500px;
    margin-top: 20px;
  }

  .name input, .phone input, .company input, .address input {
    box-sizing: border-box;
    width: 500px;
    height: 50px;
    padding: 0 12px;
    border: 1px solid #CCCCCC;
    border-radius: 2px;
    margin-bottom: 20px;
    line-height: 48px;
  }

  .describe {
    height: 100px;
    margin-bottom: 71px;
  }

  .describe textarea {
    box-sizing: border-box;
    width: 500px;
    height: 100px;
    padding: 15px 12px 0;
    border: 1px solid #CCCCCC;
    border-radius: 2px;
    margin: 0;
    resize: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/demonstration/demonstration.vue